import { TotalLine } from './TotalLine';

interface ISubtotalLine {
  subtotal: number;
}

export const SubtotalLine = ({ subtotal }: ISubtotalLine) => (
  <TotalLine dataCy={'order-amount-total'} total={subtotal} totalText={'Subtotal'} />
);
